import { FileWithPath } from 'file-selector/src/file.ts';
import { EnqueueSnackbar } from 'notistack';

export const copyTextToClipboard = async (
  text: string,
  enqueueSnackbar: EnqueueSnackbar,
) => {
  await navigator.clipboard.writeText(text).then(() => {
    enqueueSnackbar({
      message: 'Text copied to clipboard!',
      variant: 'info',
      autoHideDuration: 1000,
    });
  });
};

export const withSubRoutes = (route: string) => route.endsWith('/') ? `${route}*` : `${route}/*`;

export const sliceTextByLimit = (text: string, withEllipsis = false, limit = 100) => {
  /** Note: remove spaces at the beginning and at the end */
  const trimmedText = text.trim();

  if (trimmedText.length <= limit) {
    return trimmedText;
  } else {
    /** Note: We use (limit - 3) because the ellipsis takes up 3 characters */

    return withEllipsis ? trimmedText.slice(0, limit - 3) + '...' : trimmedText.slice(0, limit);
  }
};

export const convertToFile = (fileWithPath: FileWithPath): File => {
  return new File([fileWithPath], fileWithPath.name, {
    type: fileWithPath.type,
  });
};